import * as prodTypes from '../actionTypes';
const initialState = {
    loading: false,
};

export const wishReducer = (state = initialState, action) => {
    switch (action.type) {
        case prodTypes.GET_WISHLIST:
            return { ...state, loading: true };
        case prodTypes.GET_WISHLIST_SUCCESS:
            return { ...state, loading: false, products: action.payload };
        case prodTypes.GET_WISHLIST_FAIL:
            return { ...state, loading: false, error: action.payload };

        case prodTypes.ADD_TO_WISHLIST: {
            return { ...state, adding: true };
        }
        case prodTypes.ADD_TO_WISHLIST_SUCCESS:
            return { ...state, adding: false, product: action.payload };

        case prodTypes.ADD_TO_WISHLIST_FAIL:
            return { ...state, adding: false, error: action.payload };

        case prodTypes.REMOVE_FROM_WISHLIST:
            return { ...state, adding: true };
        case prodTypes.REMOVE_FROM_WISHLIST_SUCCESS:
            return { ...state, removing: false, product: action.payload };
        case prodTypes.REMOVE_FROM_WISHLIST_FAIL:
            return { ...state, removing: false, error: action.payload };

        case prodTypes.DELETE_FROM_WISHLIST:
            return { ...state, adding: true };
        case prodTypes.DELETE_FROM_WISHLIST_SUCCESS: {
            return {
                ...state,
                removing: false,
                products: {
                    ...state.products.items.splice(
                        ...state.products.items.filter((item) => item.id === action.payload),
                        1,
                    ),
                },
            };
        }
        case prodTypes.DELETE_FROM_WISHLIST_FAIL:
            return { ...state, removing: false, error: action.payload };

        default:
            return state;
    }
};
